import React from 'react';

interface OnboardingProgressProps {
  currentStep: 'name' | 'profession' | 'contact' | 'location' | 'experience' | 'goals' | 'terms';
}

const steps = ['name', 'profession', 'contact', 'location', 'experience', 'goals', 'terms'];

export default function OnboardingProgress({ currentStep }: OnboardingProgressProps) {
  const currentStepIndex = steps.indexOf(currentStep);
  const progress = ((currentStepIndex + 1) / steps.length) * 100;

  return (
    <div className="w-full max-w-md mx-auto mb-8">
      <div className="w-full bg-neutral rounded-full h-2">
        <div 
          className="bg-accent h-2 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}